import { render } from "./WarningIconCustom.vue?vue&type=template&id=555813e0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/WarningIconCustom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "555813e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('555813e0', __exports__)) {
    api.reload('555813e0', __exports__)
  }
  
  module.hot.accept("./WarningIconCustom.vue?vue&type=template&id=555813e0", () => {
    api.rerender('555813e0', render)
  })

}


export default __exports__